import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import CultureAds from "./culture/ads"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/cultural-ads`}>
        <CultureAds />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
